import RenderersPluginSetup from "./renderers/PluginSetup.js";
import ValidatorsPluginSetup from "./validators/PluginSetup.js";
import EditorsPluginSetup from "./editors/PluginSetup.js";
export default {
  install: molten => {
    RenderersPluginSetup.install(molten);
    ValidatorsPluginSetup.install(molten);
    EditorsPluginSetup.install(molten);
    molten.addPlugin('Attribute', {
      id: 'assetLocators.swatchAndColor',
      name: 'assetLocators.swatchAndColor',
      displayName: 'Swatch and Color',
      valueType: 'string',
      objectType: 'assetLocators',
      placement: {},
      get: obj => {
        return obj?.data?.color;
      },
      blueprint: {
        field: 'data/color'
      }
    });
    molten.addPlugin('Attribute', {
      id: 'assetLocators.openInJohnDeereButton',
      name: 'assetLocators.openInJohnDeereButton',
      displayName: 'Open In John Deere',
      valueType: 'string',
      objectType: 'assetLocators',
      placement: {},
      // Note: Dummy field, totally unrelated. Necessary for getting the displayName to show
      // up everywhere we want
      get: obj => {
        return obj?.data?.color;
      },
      blueprint: {
        field: 'data/color'
      }
    });
  }
};